import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  ButtonBase,
  Popover,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SALON_THEME_COLOR_FIELDS } from './SalonThemeColorControls';
import SalonThemeColorField from './SalonThemeColorField';


const SalonThemeEssentialColorControls = ({
  draft,
  errors = {},
  disabled = false,
  onFieldChange,
  onFieldBlur,
  registerFieldRef,
}) => {
  const { t } = useTranslation();
  const swatchRefs = useRef({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [openField, setOpenField] = useState(null);

  useEffect(() => {
    const invalidField = SALON_THEME_COLOR_FIELDS.find((field) => errors[field]);
    if (invalidField) {
      setOpenField(invalidField);
      setAnchorEl(swatchRefs.current[invalidField] || null);
    }
  }, [errors]);

  const closePopover = () => {
    setAnchorEl(null);
    setOpenField(null);
  };

  return (
    <>
      <Box
        data-testid="salon-theme-essential-swatches"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(44px, 1fr))',
        }}
        sx={{ gap: 1.25 }}
      >
      {SALON_THEME_COLOR_FIELDS.map((field) => {
        const label = t(`salon_theme.fields.${field}`);
        return (
          <ButtonBase
            key={field}
            ref={(element) => {
              swatchRefs.current[field] = element;
            }}
            aria-label={t('salon_theme.essential.edit_color', { color: label })}
            disabled={disabled}
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
              setOpenField(field);
            }}
            sx={{ minWidth: 44, minHeight: 44, borderRadius: 1.5 }}
          >
            <Box aria-hidden sx={{ width: 32, height: 32, bgcolor: draft[field], borderRadius: 1 }} />
          </ButtonBase>
        );
      })}
      </Box>
      <Popover
        open={Boolean(openField && anchorEl)}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        {openField && (
          <Box sx={{ p: 2, width: 300 }}>
            <SalonThemeColorField
              field={openField}
              label={t(`salon_theme.fields.${openField}`)}
              value={draft[openField]}
              error={errors[openField]}
              disabled={disabled}
              compact
              onChange={(value) => onFieldChange(openField, value)}
              onBlur={() => onFieldBlur(openField)}
              inputRef={(element) => registerFieldRef(openField, element)}
            />
          </Box>
        )}
      </Popover>
    </>
  );
};

export default SalonThemeEssentialColorControls;
